<template>
  <div class="duration-inputs">
    <LISAInput
      v-model.number="numberOfHours"
      type="number"
      hide-label
      :label="t('components.issueModal.duration')"
    />

    <LISASelect
      v-model="timeMultiplier"
      hide-label
      :label="
        t(
          'modules.sqdc.components.eventActionConfig.event.SQDCEventConfigComponent.dateGranularity',
        )
      "
      :options="multiplierOptions"
    />
  </div>
</template>

<script setup lang="ts">
defineOptions({ inheritAttrs: false });

import { LISAInput, LISASelect, type LISASelectOption } from "@fi-solutions/lisa-ui";
import { computed, ref } from "vue";
import { useTranslation } from "@/language/translation";
import DLZFilter from "../filterImplementations/DLZFilter";

const { t } = useTranslation();
const numberOfHours = ref<number>();
const timeMultiplier = ref<1 | 24>(24);

function getFilter() {
  return numberOfHours.value == null
    ? null
    : new DLZFilter(numberOfHours.value * timeMultiplier.value);
}

function applyFilter(filter: DLZFilter) {
  if (filter.definitionOfDLZInHours % 24 === 0) {
    timeMultiplier.value = 24;
    numberOfHours.value = filter.definitionOfDLZInHours / 24;
  } else {
    timeMultiplier.value = 1;
    numberOfHours.value = filter.definitionOfDLZInHours;
  }
}
defineExpose({
  getFilter,
  applyFilter,
});

const multiplierOptions = computed<LISASelectOption[]>(() => [
  {
    label: t("global.hours"),
    id: 1,
  },
  {
    label: t("global.days"),
    id: 24,
  },
]);
</script>

<style lang="scss" scoped>
.duration-inputs {
  display: grid;
  width: 100%;
  min-width: 0;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.5rem;
}
</style>
